// UserDetails.js
import React from "react";
import Autocomplete from "../services/autocomplete";

const UserDetails = ({
  patient,
  setPatient,
  patientDetails,
  setPatientDetails,
}) => {
  // Handle field changes for each input
  const handlePatientChange = (e) => {
    setPatient(e.target.value);
  };

  const handleSuggestionSelected = (suggestion) => {
    setPatientDetails({
      ...patientDetails,
      patient_id: suggestion.patient_id,
      phone: suggestion.phone_number,
      name: suggestion.full_name,
      gender:suggestion.gender,
      age:suggestion.age
      
    });
  };

  return (
    <div className="w-full max-w-4xl px-3">
      <Autocomplete
        name="patient"
        placeholder="Search for a patient"
        value={patient}
        onChange={handlePatientChange}
        onSuggestionSelected={handleSuggestionSelected}
        className="w-full p-2 border border-gray-300 rounded-md"
      />
      {/* Add other inputs for patient details here, using handleDetailsChange */}
    </div>
  );
};

export default UserDetails;
